import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class BusinessProcessModelEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "BusinessProcessModel";
        this.primaryEnterpriseComponent = "BusinessProcessModel";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "BusinessProcessModel";
        eom.enterpriseComponent = "BusinessProcessModel";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default BusinessProcessModelEnterpriseObjectMetadata;